import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    SAVED_ENTITY_FILTERS?: boolean;
  }
}

export default {
  featureFlags: {
    // PLAT-6808: Saved filters management view for organization
    // TODO PLAT-12477: Cleanup feature flag
    SAVED_ENTITY_FILTERS: undefined,
  },
} satisfies FeatureFlagConfig;
